// extracted by mini-css-extract-plugin
module.exports = {"container":"code-layout--container--3uUir","redDash":"code-layout--redDash--Ov_T6","logo":"code-layout--logo--VAsTa","slideNumber":"code-layout--slideNumber---Qfgv"};